import { User } from "../types/user";

type NavigateFunction = (path: string) => void;

export const navigateToDashboard = (user: User, navigate: NavigateFunction) => {
  const roleName = user.role?.name || ""; // role objesi boş olabilir diye optional chaining
console.log(user)

  // 1. Sistem Yöneticileri (Sabit roller)
  if (roleName === "super_admin" || roleName === "admin") {
    return navigate("/admin/dashboard");
  }

  // 2. Müşteriler (Eğer ayrı bir paneliniz varsa)
  if (roleName === "customer") {
    return navigate("/customer");
  }

  
  // 3. DİNAMİK ROLLER: Eğer bir firmId varsa, rol ismi ne olursa olsun 
  // (Muhasebeci, Depocu vb.) firma paneline yönlendir.
  if (user.firmId) {
    return navigate("/firm/dashboard");
  }

  // 4. Hiçbiri değilse güvenli çıkış
  console.warn("Tanımlanamayan rol veya firma bağlantısı yok:", roleName);
  navigate("/login");
};